import React from 'react';
import {Box, Tooltip, makeStyles} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import {Package as PackageIcon} from 'react-feather';
import DeleteIconDialog from 'components/DeleteIconDialog';
import getApiConnectorRoute from "../apiRoutes";

const useStyles = makeStyles((theme) => ({
    root: {},
    rowButtons: {
        padding: '5px'
    }
}));

const ConnectorListActions = ({ connector, loadData, ...rest }) => {
    const classes = useStyles();
    const { t } = useTranslation('connector');
    const navigate = useNavigate();

    return (
        <Box display="flex" justify="flex-end" justifyContent="flex-end">
            <Tooltip title={t('button.orders')} aria-label={t('button.orders')}>
                <IconButton
                    aria-label={t('button.orders')}
                    className={classes.rowButtons}
                    size="small"
                    onClick={() => {
                        navigate('/app/connector/packages', {
                            state: {
                                processor: connector.processor,
                                id: connector.id
                            }
                        });
                    }}
                >
                    <PackageIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title={t('button.edit')} aria-label={t('button.edit')}>
                <IconButton
                    aria-label={t('button.edit')}
                    className={classes.rowButtons}
                    size="small"
                    onClick={() => {
                        navigate('/app/connector/new', {
                            state: {
                                id: connector.id,
                                processor: {
                                    id: connector.processor,
                                    label: ''
                                }
                            }
                        });
                    }}
                >
                    <EditIcon />
                </IconButton>
            </Tooltip>
            <DeleteIconDialog
                text={
                    <React.Fragment>
                        {t('messages.delete_connector')}
                    </React.Fragment>
                }
                route={getApiConnectorRoute('delete', [connector.id])}
                onDelete={loadData}
            />
        </Box>
    )
}

export default ConnectorListActions;